import { FormType } from '../../../../Model/Form';

const FormSettingsEvent = {
  SAVED: 'form_saved',
  CREATED: 'form_created',
};

const FormTab = {
  POST_PAYMENT: 'POST_PAYMENT',
  LEAD: 'LEAD',
};

const tabFormType = {
  [FormTab.POST_PAYMENT]: FormType.POST_PAYMENT,
  [FormTab.LEAD]: FormType.LEAD,
};

export { FormSettingsEvent, FormTab, tabFormType };
